export const MAX_REPORTING_ID_LENGTH = 128

const REPORTING_ID_PATTERN = /^[A-Za-z0-9][A-Za-z0-9._:-]*$/

export const reportingIdentifier = (value: unknown, name: string): string => {
  if (typeof value !== 'string' || value.length === 0 || value.trim() !== value)
    throw new Error(`${name} must be a non-empty trimmed identifier`)
  if (value.length > MAX_REPORTING_ID_LENGTH) {
    throw new Error(
      `${name} must be at most ${MAX_REPORTING_ID_LENGTH} characters`,
    )
  }
  if (!REPORTING_ID_PATTERN.test(value)) {
    throw new Error(`${name} must be a safe identifier`)
  }
  return value
}

export const isReportingIdentifier = (value: unknown): value is string => {
  try {
    reportingIdentifier(value, 'identifier')
    return true
  } catch {
    return false
  }
}
